<template>
<b-col md="8" sm="12" class="p-0 m-0">
    <div class="row tw-text-16px tw-font-light pb-3 color-brand-3 text-center">
        <div class="col-6 col-md-3">
            <img src="/assets/travel/icons/icon-location_FDA-blue.svg" class="tw-inline-block mb-2" alt="location"><br>
            {{ collector.country_iso_3 }}
        </div>
        <div class="col-6 col-md-3">
            <img src="/assets/travel/icons/icon-plane-FDA-blue.svg" class="tw-inline-block mb-2" alt="plane"><br>
            {{ collector.transport }}
        </div>
        <div class="col-6 col-md-3">
            <img src="/assets/travel/icons/icon-calendar-FDA.svg" class="tw-inline-block mb-2" alt="calendar"><br>
            {{ collector.start_date.substring(0,5) }} - {{ collector.end_date.substring(0,5) }}
        </div>
        <div class="col-6 col-md-3">
            <img src="/assets/travel/icons/icon-acoperire-FDA-blue.svg" class="tw-inline-block mb-2" alt="shield"><br>
            {{ collector.purpose_name }}
        </div>
    </div>
</b-col>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "CollectorDataIcons",
  computed: {
    ...mapGetters(['collector']),
  }
}
</script>

<style scoped>

</style>